import {mapTodoDbToType, type Todo} from '@cp/model';
import {onSnapshot, query} from 'firebase/firestore';
import mapFirestoreQuerySnapshotToData from '../../helper/firebase/mapFirestoreQuerySnapshotToData';
import {getTodoCollection} from './getTodoCollection';

export default function subscribeTodoCollection(
  uid: string,
  onData: (todos: Todo[]) => void,
  onError?: (err: Error) => void,
): () => void {
  const col = getTodoCollection(uid);
  const q = query(col);
  return onSnapshot(
    q,
    (snapshot) => {
      onData(mapFirestoreQuerySnapshotToData(snapshot, mapTodoDbToType));
    },
    (err) => onError?.(err),
  );
}
